import(/* webpackMode: "eager", webpackExports: ["DeletedAccountPageContent"] */ "/vercel/path0/apps/web/src/sections/profile/components/DeletedAccountPageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfilePageContent"] */ "/vercel/path0/apps/web/src/sections/profile/ProfilePageContent.tsx");
